
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { renderAtheismDefenseContent } from './detailRenderers/AtheismDefenseRenderer';
import { renderBiblicalDefenseContent } from './detailRenderers/BiblicalDefenseRenderer';
import { renderInterfaithDialogueContent } from './detailRenderers/InterfaithDialogue';
import { renderPrayerContent } from './detailRenderers/PrayerRenderer';
import { renderReadingPlanContent } from './detailRenderers/ReadingPlanRenderer';
import { renderFindYourVerseContent } from './detailRenderers/FindYourVerseRenderer';
import { renderScriptureNavigatorContent } from './detailRenderers/ScriptureNavigatorRenderer';
import { renderDeepDiveContent } from './detailRenderers/DeepDiveRenderer';
import { renderEtymologyContent } from './detailRenderers/EtymologyRenderer';
import { renderMoralDilemmasContent } from './detailRenderers/MoralDilemmasRenderer';

interface ResponseDetailProps {
  item: any;
}

export const ResponseDetail: React.FC<ResponseDetailProps> = ({ item }) => {
  const navigate = useNavigate();

  const renderDetailContent = () => {
    if (!item || !item.content) return <p className="bg-white p-4">No content available</p>;

    switch (item.tool_type) {
      case 'atheism_defense':
        return renderAtheismDefenseContent(item, navigate);
      case 'biblical_defense':
        return renderBiblicalDefenseContent(item, navigate);
      case 'interfaith_dialogue':
        return renderInterfaithDialogueContent(item, navigate);
      case 'prayer':
        return renderPrayerContent(item, navigate);
      case 'reading_plan':
        return renderReadingPlanContent(item, navigate);
      case 'find_your_verse':
        return renderFindYourVerseContent(item, navigate);
      case 'scripture_navigator':
        return renderScriptureNavigatorContent(item, navigate);
      case 'deep_dive':
        return renderDeepDiveContent(item, navigate);
      case 'etymology':
        return renderEtymologyContent(item, navigate);
      case 'moral_dilemmas':
        return renderMoralDilemmasContent(item, navigate);
      default:
        return <p className="bg-white p-4">No preview available for this content type.</p>;
    }
  };

  return (
    <div className="bg-white w-full h-full overflow-y-auto p-4"> {/* Explicitly set white background, full width and height, with scrolling and padding */}
      {renderDetailContent()}
    </div>
  );
};

export default ResponseDetail;

